import './Card.scss';
import './Content/Event.scss';
import { forAll } from '@bopf/util';

forAll('.js-card', card => {

    if (document.body.classList.contains('neos-backend')) {
        return;  // do nothing
    }
    else {
        card.style.cursor = 'pointer';
        let down, up, link = card.querySelector('.card__link');
        card.onmousedown = () => down = +new Date();
        card.onmouseup = (e) => {
            // only respond to left mouse button
            if (e.which !== 1) {
                return;
            }
            up = +new Date();
            if (up - down < 200) {
                link.click();
            }
        };

        card.addEventListener('focus', function() {
            card.classList.add('focus-within');
        }, true);
        card.addEventListener('blur', function() {
            card.classList.remove('focus-within');
        }, true);
    }
});
